import React, { Fragment } from 'react'
import { Portal } from 'react-portal'
import cx from 'classnames'
import { injectIntl } from 'sb-react-intl'
import { useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'

import CartSidebar from 'components/cart/Sidebar/Sidebar'
import { ReactComponent as Icon } from 'components/_new/ui/Icon/images/nav/cart.svg'

import messages from './messages'
import s from './CartButton.scss'


const CartButton = ({ intl, className }) => {
  const { isNotEmpty } = useConnect({
    isNotEmpty: (state) => Boolean(state.models.cart.totalCount),
  })

  const handleClick = useCallback(() => {
    snowplow.track(constants.snowplowEvents.cartClick)
    actions.models.cart.open()
  }, [])

  const rootClassName = cx(s.button, className, {
    [s.notEmpty]: isNotEmpty,
  })

  return (
    <Fragment>
      <button
        className={rootClassName}
        type="button"
        aria-label={intl.formatMessage(messages.cart)}
        onClick={handleClick}
      >
        <Icon />
      </button>
      <Portal>
        <CartSidebar />
      </Portal>
    </Fragment>
  )
}


export default injectIntl(CartButton)
